export default "__VITE_ASSET__BmMwFlt1__"